import type { ClientInvite } from '@/types/invites';

const KEY = 'coachd-invites';
const read = (): ClientInvite[] => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
};
const write = (rows: ClientInvite[]) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(rows));
  } catch {
    // OBS-11 a-ignore: localStorage throws in private mode / when full; this is a best-effort cache and the app works without it.
  }
};

export const localInvitesStore = {
  async listByCoach(coachId: string) {
    return read().filter((i) => String(i.coachId) === String(coachId));
  },
  async listByEmail(email: string) {
    return read().filter((i) => i.email?.toLowerCase() === email?.toLowerCase());
  },
  async get(id: string) {
    return read().find((i) => String(i.id) === String(id)) || null;
  },
  async insert(inv: ClientInvite) {
    const rows = read();
    rows.unshift(inv);
    write(rows);
    return inv;
  },
  async update(id: string, patch: Partial<ClientInvite>) {
    const rows = read();
    const idx = rows.findIndex((r) => String(r.id) === String(id));
    if (idx >= 0) {
      rows[idx] = { ...rows[idx], ...patch };
      write(rows);
      return rows[idx];
    }
    return null;
  },
  async remove(id: string) {
    const rows = read();
    const next = rows.filter((r) => String(r.id) !== String(id));
    write(next);
    return next.length !== rows.length;
  },
};
